import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import { Link } from "react-router-dom";
import { usePageTitle } from "@/hooks/usePageTitle";

const milestones = [
  { year: "2019", events: ["北九州市小倉北区赤坂の自宅にて藤本工業設立"] },
  { year: "2022", events: ["小倉北区赤坂ビル1Fにて株式会社JAPANPACIFICDIVERS設立"] },
  { year: "2024", events: ["藤本工業閉業"] },
];

export default function AboutPage() {
  usePageTitle("会社概要");
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <section className="pt-24 md:pt-32 pb-12 md:pb-16 bg-ocean-800">
          <div className="px-4 md:px-8 lg:px-12">
            <div className="max-w-6xl mx-auto">
              <div className="mb-8">
                <h1 className="font-serif text-3xl md:text-5xl font-bold text-white">
                  会社概要
                </h1>
              </div>
            </div>
          </div>
        </section>

        <section className="py-12 md:py-20 bg-ocean-50">
          <div className="px-4 md:px-8 lg:px-12">
            <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-12 items-start">
              <div>
                <div className="rounded-2xl overflow-hidden">
                  <img
                    src="https://static.readdy.ai/image/8e81880eb50dc98f95be220d1124e175/ae6fbbe392d5a3754e95e53133b0d1d8.jpeg"
                    alt="潜水作業の様子"
                    className="w-full h-96 md:h-[480px] object-cover" style={{objectPosition: '0% 50%'}}
                  />
                </div>
              </div>

              <div className="space-y-6">
                <div className="bg-white rounded-2xl p-6 md:p-8 border border-ocean-100">
                  <div className="flex items-center gap-2 mb-5">
                    <i className="ri-file-list-line text-ocean-500" />
                    <span className="text-xs font-semibold text-ocean-500 tracking-wider">
                      COMPANY PROFILE
                    </span>
                  </div>
                  <div className="space-y-4">
                    {[
                      { label: "会社名", value: <span>株式会社JAPANPACIFICDIVERS<br />（ジャパンパシフィックダイバーズ）</span> },
                      { label: "設立", value: "2022年6月" },
                      { label: "代表者", value: "藤本勇二" },
                      { label: "資本金", value: "200万円" },
                      { label: "従業員数", value: "7名（2026年4月現在）" },
                      { label: "所在地", value: "福岡県北九州市小倉北区赤坂3丁目6-22-206号室" },
                      { label: "TEL", value: "093-287-2050" },
                      { label: "FAX", value: "093-330-4368" },
                      { label: "事業内容", value: "海洋工事・SV業務・電気通信" },
                    ].map((item) => (
                      <div
                        key={item.label}
                        className="flex flex-col sm:flex-row sm:gap-4 pb-3 border-b border-ocean-50 last:border-0"
                      >
                        <span className="text-xs font-semibold text-ocean-400 sm:w-24 shrink-0">
                          {item.label}
                        </span>
                        <span className="text-sm text-ocean-700">
                          {item.value}
                        </span>
                      </div>
                    ))}
                  </div>
                </div>

                <div className="flex gap-4 mt-[-8px]">
                  {[
                    { value: "4", unit: "年", label: "創業年数" },
                    { value: "7", unit: "名", label: "従業員数" },
                  ].map((stat) => (
                    <div
                      key={stat.label}
                      className="bg-ocean-50 rounded-xl p-4 text-center"
                    >
                      <div className="flex items-baseline justify-center gap-0.5">
                        <span className="text-2xl md:text-3xl font-bold text-ocean-600 font-serif">
                          {stat.value}
                        </span>
                        <span className="text-sm font-bold text-ocean-500">
                          {stat.unit}
                        </span>
                      </div>
                      <p className="text-xs text-ocean-500 mt-1">{stat.label}</p>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* 代表挨拶セクション */}
        <section className="py-12 md:py-20 bg-white">
          <div className="px-4 md:px-8 lg:px-12">
            <div className="max-w-6xl mx-auto">
              <div className="flex items-center gap-3 mb-10">
                <span className="inline-block px-4 py-1.5 text-xs font-semibold tracking-widest text-ocean-500 border border-ocean-500 rounded-full">
                  MESSAGE
                </span>
                <h2 className="font-serif text-2xl md:text-3xl font-bold text-ocean-800">
                  代表挨拶
                </h2>
              </div>

              <div className="grid grid-cols-1 lg:grid-cols-3 gap-8 md:gap-12 items-start">
                <div className="lg:col-span-1">
                  <div className="rounded-2xl overflow-hidden">
                    <div className="w-full h-80 md:h-96">
                      <img
                        src="https://static.readdy.ai/image/8e81880eb50dc98f95be220d1124e175/b899590fc90a372ab8fe5cb4140518da.jpeg"
                        alt="代表取締役社長"
                        className="w-full h-full object-cover object-top"
                      />
                    </div>
                  </div>
                  <div className="mt-4 text-center">
                    <p className="text-xs text-ocean-400 tracking-wider mb-1">代表取締役</p>
                    <p className="font-serif text-lg font-bold text-ocean-800">藤本 勇二</p>
                  </div>
                </div>

                <div className="lg:col-span-2 flex flex-col gap-5">
                  <div className="text-center">
                    <p className="font-serif text-2xl md:text-3xl font-bold text-ocean-800 leading-relaxed">
                      「日本の海から、世界の海へ。」
                    </p>
                  </div>

                  <div className="space-y-4 text-base md:text-lg text-ocean-600 leading-relaxed">
                    <p>
                      弊社は2019年の創業以来、潜水士として海底ケーブル敷設工事・港湾工事・防蝕工事・海底調査など、
                      日本の海から世界の海まで幅広い海洋工事を手がけてまいりました。
                    </p>
                    <p>
                      潜水士業務にとどまらず、SV業務（ダイバー作業監督・ロボットによる海底ケーブル敷設監督）や
                      電気通信工事（海底ケーブル電気試験・5Gアンテナ取付等）にも対応し、
                      海洋インフラを総合的に支える会社として成長を続けています。飽和潜水ダイバーも在籍しておりますので、深海100m以上での作業も対応可能です。
                    </p>
                    <p>
                      業界未経験の方も資格取得サポートを通じて活躍できる環境を整えており、
                      これからも「安全第一」の精神のもと、日本の海から世界の海へ貢献し続けてまいります。
                      どうぞお気軽にご相談ください。
                    </p>
                  </div>


                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="py-12 md:py-20 bg-ocean-50">
          <div className="px-4 md:px-8 lg:px-12">
            <div className="max-w-6xl mx-auto">
              <h2 className="font-serif text-2xl md:text-3xl font-bold text-ocean-800 mb-10 md:mb-12">
                会社の歩み
              </h2>

              <div className="space-y-6">
                {milestones.map((milestone) => (
                  <div key={milestone.year} className="flex gap-8 items-start">
                    <div className="flex-shrink-0 w-16">
                      <span className="text-lg md:text-2xl font-bold text-ocean-500 font-serif">
                        {milestone.year}
                      </span>
                    </div>
                    <div className="flex-1">
                      <ul className="space-y-1">
                        {milestone.events.map((event, i) => (
                          <li key={i} className="text-sm md:text-base text-ocean-700">
                            {event}
                          </li>
                        ))}
                      </ul>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </section>

        <section className="py-12 md:py-16 bg-ocean-50">
          <div className="px-4 md:px-8 lg:px-12">
            <div className="max-w-4xl mx-auto text-center">
              <h2 className="font-serif text-xl md:text-2xl font-bold text-ocean-800 mb-4">
                より詳しい情報はお問い合わせください
              </h2>
              <Link
                to="/contact"
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-ocean-500 hover:bg-ocean-400 text-white font-medium rounded-full transition-all whitespace-nowrap"
              >
                お問い合わせ
                <i className="ri-arrow-right-line" />
              </Link>
            </div>
          </div>
        </section>


      </main>
      <Footer />
    </div>
  );
}